import type { PlayerProgressionSummary, Profile } from '@/types/domain';

const ATTENDANCE_PER_LEVEL = 5;

interface ProgressionTier {
  minimumLevel: number;
  label: string;
}

const progressionTiers: ProgressionTier[] = [
  { minimumLevel: 1, label: 'Recruit' },
  { minimumLevel: 4, label: 'Frontliner' },
  { minimumLevel: 8, label: 'Vanguard' },
  { minimumLevel: 12, label: 'Warhound' },
  { minimumLevel: 18, label: 'Veteran' },
  { minimumLevel: 26, label: 'Alpha' },
];

export function getAttendanceLevel(attendanceCount: number): number {
  return Math.max(1, Math.floor(attendanceCount / ATTENDANCE_PER_LEVEL) + 1);
}

export function getProgressionTier(level: number): string {
  return [...progressionTiers]
    .reverse()
    .find((tier) => level >= tier.minimumLevel)?.label ?? progressionTiers[0].label;
}

export function getPlayerProgression(profile: Profile, attendanceCount: number): PlayerProgressionSummary {
  const baseLevel = getAttendanceLevel(attendanceCount);
  const level = profile.progressionLevelOverride ?? baseLevel;

  return {
    profileId: profile.id,
    level,
    tier: getProgressionTier(level),
    attendanceCount,
    isManualOverride: typeof profile.progressionLevelOverride === 'number',
  };
}
